<div style="background: white; border-radius: 16px; overflow: hidden; max-width: 480px; margin: 0 auto;">
  <!-- Header -->
  <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0; text-align: center;">
    <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
      <mat-icon style="font-size: 22px; width: 22px; height: 22px; color: #1C593D;">security</mat-icon>
      <span style="font-size: 1rem; font-weight: 800; color: #1e5a3f;">Configurar MFA</span>
    </div>
  </div>

  <!-- Step 1: QR Code + clave manual -->
  <div *ngIf="step === 1" style="padding: 24px; text-align: center;">
    <p style="font-size: 0.9rem; color: #374151; font-weight: 500; margin: 0 0 8px;">
      Configura tu Google Authenticator
    </p>
    <p style="font-size: 0.78rem; color: #6b7280; margin: 0 0 20px;">
      Tenés dos opciones: escanear el código QR o ingresar la clave manualmente en la app.
    </p>

    <!--
      El QR no se pudo generar. Antes esto era un recuadro vacío sin
      explicación, que se leía como "no me deja activarlo".
    -->
    <div *ngIf="errorQr" role="alert"
      style="display: flex; align-items: flex-start; gap: 10px; margin-bottom: 18px; padding: 12px 14px; background: #fef2f2; border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 10px; text-align: left;">
      <mat-icon style="color: #dc2626; font-size: 20px; width: 20px; height: 20px; flex-shrink: 0;">error_outline</mat-icon>
      <div style="flex: 1; min-width: 0;">
        <span style="display: block; color: #991b1b; font-size: 0.82rem; line-height: 1.45;">{{ errorQr }}</span>
        <button type="button" (click)="reintentarQr()"
          style="margin-top: 8px; display: inline-flex; align-items: center; gap: 6px; padding: 7px 16px; background: white; color: #991b1b; border: 1px solid #fecaca; border-radius: 8px; font-weight: 700; font-size: 0.78rem; cursor: pointer;">
          Reintentar
        </button>
      </div>
    </div>

    <!-- Opción 1: QR -->
    <div style="margin-bottom: 18px;">
      <p style="font-size: 0.72rem; font-weight: 700; color: #1e5a3f; text-transform: uppercase; letter-spacing: 0.4px; margin: 0 0 10px;">
        Opción 1 · Escanear QR
      </p>
      <div style="display: flex; justify-content: center;">
        <qrcode *ngIf="qrData" [qrdata]="qrData" [width]="200" [errorCorrectionLevel]="'M'"></qrcode>
      </div>
    </div>

    <!-- Divider "o" -->
    <div style="display: flex; align-items: center; gap: 10px; margin: 18px 0;">
      <span style="flex: 1; height: 1px; background: #e5e7eb;"></span>
      <span style="font-size: 0.72rem; font-weight: 700; color: #9ca3af; text-transform: uppercase; letter-spacing: 0.4px;">o</span>
      <span style="flex: 1; height: 1px; background: #e5e7eb;"></span>
    </div>

    <!-- Opción 2: clave manual -->
    <div style="margin-bottom: 24px; text-align: left;">
      <p style="font-size: 0.72rem; font-weight: 700; color: #1e5a3f; text-transform: uppercase; letter-spacing: 0.4px; margin: 0 0 8px; text-align: center;">
        Opción 2 · Ingresar clave manualmente
      </p>
      <p style="font-size: 0.78rem; color: #6b7280; margin: 0 0 8px; text-align: center;">
        En tu app elegí "Ingresar clave de configuración" y pegá:
      </p>
      <div *ngIf="secret"
        style="display: flex; align-items: center; gap: 8px; background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 10px; padding: 10px 12px;">
        <span style="flex: 1; font-family: monospace; font-size: 0.95rem; font-weight: 700; color: #1e5a3f; letter-spacing: 1.5px; word-break: break-all; text-align: center;">
          {{ secretFormatted }}
        </span>
        <button type="button" title="Copiar clave" (click)="copySecret()"
          style="display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: 1px solid #1C593D; border-radius: 8px; background: white; color: #1C593D; cursor: pointer; flex-shrink: 0;"
          onmouseover="this.style.background='#ecfdf5'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px;">content_copy</mat-icon>
        </button>
      </div>
      <p style="font-size: 0.7rem; color: #9ca3af; font-style: italic; margin: 8px 0 0; text-align: center;">
        Tipo de clave: <strong>Basada en tiempo</strong> · Algoritmo: <strong>SHA-1</strong> · Dígitos: <strong>6</strong>
      </p>
    </div>

    <div style="display: flex; justify-content: center; gap: 12px;">
      <button type="button" (click)="onNoClick()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        Atrás
      </button>
      <button type="button" (click)="nextStep(1)"
        style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        Siguiente
      </button>
    </div>
  </div>

  <!-- Step 2: Code Verification -->
  <div *ngIf="step === 2" style="padding: 24px; text-align: center;">
    <p style="font-size: 0.9rem; color: #374151; font-weight: 500; margin: 0 0 20px;">
      Ingresa el código generado por la aplicación
    </p>
    <div style="max-width: 280px; margin: 0 auto 24px;">
      <mat-form-field appearance="outline" class="modern-field" style="width: 100%;">
        <mat-label>Código</mat-label>
        <input matInput
          type="text"
          [(ngModel)]="code"
          placeholder="Ingresa el código"
          maxlength="6"
          pattern="[0-9]*"
          (keypress)="validateNumberInput($event)">
      </mat-form-field>
    </div>
    <div style="display: flex; justify-content: center; gap: 12px;">
      <button type="button" (click)="onNoClick()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        Atrás
      </button>
      <button type="button" (click)="nextStep(2)"
        style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        Verificar
      </button>
    </div>
  </div>
</div>
